import { useEffect, useRef } from 'react';
import { useShiftStore } from './shift-store';
import { useToast } from '@/hooks/use-toast';
import { useCurrentShift, useShiftControls } from './shift-controller';
import { Timer } from '@/components/time/countdown-timer';
import { formatDuration } from '../time';
import { Button } from '@/components/ui/button';

export const ShiftBreachToaster = () => {
  const shift = useCurrentShift();
  const toastId = useRef<string>();
  const hasBreached = useShiftStore((s) => s.hasBreached);
  const controls = useShiftControls();
  const { toast, dismiss } = useToast();

  const handleStartShift = async () => {
    controls.startShift();
    dismiss(toastId.current);
  };

  useEffect(() => {
    if (shift.shift != null) {
      toastId.current = undefined;
    }
  }, [shift.shift != null, toastId]);

  useEffect(() => {
    console.log(toastId, hasBreached);
    if (toastId.current != null || !hasBreached) return;

    console.debug('Showing KPI breach toast...');
    const t = toast({
      title: (
        <div className="flex items-center gap-x-2">
          <p>
            Removed from monitoring queue (
            <Timer time={shift.idleAt} format={(ms) => formatDuration(ms, 'numeric')} /> ago)
          </p>
        </div>
      ),
      variant: 'default',
      duration: Infinity,
      description:
        'Your inactivity has exceeded the allowed threshold. Start another shift to resume monitoring.',
      action: (
        <Button onClick={handleStartShift} variant="blurred" className="w-full sm:w-auto">
          Start shift
        </Button>
      ),
    });
    toastId.current = t.id;
  }, [toastId, shift.idleAt != null, hasBreached]);

  return null;
};
